import { render, staticRenderFns } from "./LavorazioneConvoglioArrivo.vue?vue&type=template&id=451f1f60&scoped=true"
import script from "./LavorazioneConvoglioArrivo.vue?vue&type=script&lang=js"
export * from "./LavorazioneConvoglioArrivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f1f60",
  null
  
)

export default component.exports